var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
		linkTag.crossOrigin = "anonymous";
	}
	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	78068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"1526":1,"2528":1,"3826":1,"3855":1,"4315":1,"5535":1,"6589":1,"6993":1,"7217":1,"8124":1,"8310":1,"8749":1,"9362":1,"9678":1,"10161":1,"11076":1,"11413":1,"11520":1,"11695":1,"11961":1,"13305":1,"13384":1,"15843":1,"17792":1,"18512":1,"20446":1,"21168":1,"21775":1,"23212":1,"24469":1,"24527":1,"24559":1,"25174":1,"25182":1,"27984":1,"28106":1,"28662":1,"28683":1,"32593":1,"32845":1,"33362":1,"34533":1,"34584":1,"36780":1,"36986":1,"37339":1,"38474":1,"39642":1,"43751":1,"45782":1,"46032":1,"46952":1,"48538":1,"49153":1,"50360":1,"50444":1,"51496":1,"51984":1,"52203":1,"53164":1,"55448":1,"55991":1,"58584":1,"58716":1,"59218":1,"60190":1,"60387":1,"61965":1,"62110":1,"63183":1,"63406":1,"63676":1,"63948":1,"64580":1,"65125":1,"65757":1,"65957":1,"66809":1,"66892":1,"67189":1,"67388":1,"71857":1,"73031":1,"74075":1,"75053":1,"75449":1,"76528":1,"77966":1,"77994":1,"78413":1,"79097":1,"80770":1,"81423":1,"82098":1,"82848":1,"82851":1,"83567":1,"85564":1,"85861":1,"86670":1,"87127":1,"89962":1,"90030":1,"90590":1,"91397":1,"91426":1,"91516":1,"91817":1,"92204":1,"92536":1,"93310":1,"94246":1,"95789":1,"95856":1,"97662":1,"97789":1,"98508":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr